import { render } from "./annualLossCom.vue?vue&type=template&id=21c6373e&scoped=true"
import script from "./annualLossCom.vue?vue&type=script&lang=js"
export * from "./annualLossCom.vue?vue&type=script&lang=js"

import "./annualLossCom.vue?vue&type=style&index=0&id=21c6373e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c6373e"]])

export default __exports__